import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn
} from '@angular/forms';
/**
 * 驗證是否為相同值
 */
@Directive({
  selector: '[appEqualTo]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: EqualToDirective, multi: true },
  ],
})
export class EqualToDirective implements Validator {
  @Input('appEqualTo') compareValue = '';

  validate(control: AbstractControl): ValidationErrors | null {
    return equalToValidator(this.compareValue)(control);
  }
}

export function equalToValidator(compareValule: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return compareValule === control.value
      ? null
      : { equalTo: { value: control.value } };
  };
}
